trackingConfig.$inject = ['$analyticsProvider', 'trackerProvider'];

function trackingConfig($analyticsProvider, trackerProvider) {
  //// If tracking is disabled. Default is false.
  // If set to true tracking won't initialize, i.e. the piwik script
  // won't be loaded and hence no data is send to the server.
  // (Still tracking log messages on localhost are visible.)
  // Servers configuration is completely ignored.
  // Can be also set in the config section of another module (e.g. GEA).
  // trackerProvider.disabled = true;
  // TODO HACK since the current grunt build does not support
  // optional file inclusion (with targethtml) we use a ugly
  // global variable
  /* global window */
  window.disableTracking = window.disableTracking || false;
  trackerProvider.disabled = window.disableTracking === true;

  //// Angulartics: disable automatic route tracking
  // since we do it ourselves
  $analyticsProvider.virtualPageviews(false);

  //// Piwik servers setup for serving from host
  // CFNPOC-7444 The hosts property is an array of host names or md5-hashes of host names
  // md5-hashes should be used for production, host names are for testing only
  // The first server and site which contains the current hostname will be used
  // To disable set to empty array, i.e. [] - better set trackerProvider.disables = true
  // can be generated with: echo -n to_be_hashed | md5sum
  trackerProvider.servers = [
    {
      // dev & test
      url: 'https://tracktest.365farmnet.com',
      sites: [
        {
          id: 3, //prev
          hosts: ['ef023c32fa6878c7deab51da2d734181']
        },
        {
          id: 9, //pp
          hosts: ['34dace6e819a7bf2390d90fb5bccc045']
        },
        {
          id: 16, //citest.365farmnet.com
          hosts: ['eef6b97e746e57ad5abba6f92a0b85b1']
        },
        {
          id: 4, //test
          hosts: ['289451bed51244666d93d94ef551e056']
        },
        {
          id: 17, //1
          hosts: ['e848c8e100389872503077f11d558d0e']
        },
        {
          id: 18,
          hosts: ['b5acbc7c5a1c6f0921bd2d1a4dc120c5']
        },
        {
          id: 19,
          hosts: ['89a4ae51f57fd15b572346f61ebdf692']
        },
        {
          id: 20,
          hosts: ['57e222c415d8720fae713240b3d9f5ea']
        },
        {
          id: 21,
          hosts: ['40b2efe779efc6c3347ca94c2ef5ac82']
        },
        {
          id: 22,
          hosts: ['5f3b908057430389f4e3e26b442b5b51']
        },
        {
          id: 23,
          hosts: ['983c238f16a68e57481952fab04beddf']
        },
        {
          id: 24, //8
          hosts: ['20b3d02d66ff65dee06fe6c9ce5e87cc']
        },
        {
          id: 27, //devcon
          hosts: ['f4d201ba51127d60d1a71b28b473ff52']
        }
      ]
    },
    {
      // Productive Live Site
      url: 'https://statistic.365farmnet.com',
      sites: [
        {
          id: 1,
          hosts: ['56fdf72bc5cd178dec6edafa37dfdfb0']
        },
        {
          id: 2,
          hosts: ['d94a20cee978f6ddfc2c95a315ecc691']
        }
      ]
    }
  ];

  //// If the user should be tracked, so he is unique to piwik
  // by saving his login-name (app.credentials.userId)
  trackerProvider.trackUser = true;

  //// If links should be tracked automatically
  trackerProvider.enableLinkTracking = true;

  //// Goal Ids setup
  // must be the same for every Piwik instance
  // registration
  trackerProvider.goalIds.register = 1;
  // buy, test and freemium have as properties the lower-case name of the service key.
  // Other service keys can be added without further adaption.
  // 2..4 obsolete
  // CLA
  trackerProvider.goalIds.buy.cla = 5;
  trackerProvider.goalIds.test.cla = 6;
  // ZUG
  trackerProvider.goalIds.buy.zug = 7;
  trackerProvider.goalIds.test.zug = 8;
  // KWS
  trackerProvider.goalIds.buy.kws = 9;
  trackerProvider.goalIds.test.kws = 10;
  // LAGE
  trackerProvider.goalIds.buy.lage = 11;
  trackerProvider.goalIds.test.lage = 12;
  // AMAZ
  trackerProvider.goalIds.buy.amaz = 13;
  trackerProvider.goalIds.test.amaz = 14;
  // AGR
  trackerProvider.goalIds.buy.agr = 15;
  trackerProvider.goalIds.test.agr = 16;
  // ISIP
  trackerProvider.goalIds.buy.isip = 17;
  trackerProvider.goalIds.test.isip = 18;
  // PLAN
  trackerProvider.goalIds.buy.plan = 19;
  trackerProvider.goalIds.test.plan = 20;
  // ISO-XML
  trackerProvider.goalIds.buy.isoxml = 21;
  trackerProvider.goalIds.test.isoxml = 22;
  // GEA
  trackerProvider.goalIds.buy.gea = 23;
  trackerProvider.goalIds.test.gea = 24;
  trackerProvider.goalIds.free.gea = 27;
  // CLAAS ROUTE OPTIMIZATION
  trackerProvider.goalIds.buy.claroute = 28;
  trackerProvider.goalIds.test.claroute = 29;
  // METEOBLUE Profiwetter
  trackerProvider.goalIds.buy.wtprofi = 30;
  trackerProvider.goalIds.test.wtprofi = 31;
  // Fuetterung
  trackerProvider.goalIds.buy.forage = 33;
  trackerProvider.goalIds.test.forage = 34;
  trackerProvider.goalIds.free.forage = 35;
  // Spray Weather
  trackerProvider.goalIds.buy.spraywt = 36;
  trackerProvider.goalIds.test.spraywt = 37;
  // Milking
  trackerProvider.goalIds.buy.milking = 38;
  trackerProvider.goalIds.test.milking = 39;
  trackerProvider.goalIds.free.milking = 40;
  // SAATBAU Profit Manager
  trackerProvider.goalIds.buy.saatbau = 41;
  trackerProvider.goalIds.test.saatbau = 42;
  // GEADPSYNC
  trackerProvider.goalIds.buy.geadpsync = 43;
  trackerProvider.goalIds.test.geadpsync = 44;
  // YARAPLAN
  trackerProvider.goalIds.buy.yaraplan = 45;
  trackerProvider.goalIds.test.yaraplan = 46;
  trackerProvider.goalIds.free.yaraplan = 47;
  // GEADPSYNCMILKING
  trackerProvider.goalIds.buy.geadpsyncmilking = 48;
  trackerProvider.goalIds.test.geadpsyncmilking = 49;
  // CLAASCROPVIEW
  trackerProvider.goalIds.buy.claascropview = 50;
  trackerProvider.goalIds.test.claascropview = 51;
  // IOTACTIVE
  trackerProvider.goalIds.buy.iotactive = 52;
  trackerProvider.goalIds.test.iotactive = 53;
  // APDIFIELDSYNC
  trackerProvider.goalIds.buy.apdifieldsync = 54;
  trackerProvider.goalIds.test.apdifieldsync = 55;
  trackerProvider.goalIds.free.apdifieldsync = 56;
  // MICHELIN
  trackerProvider.goalIds.buy.michelin = 57;
  trackerProvider.goalIds.test.michelin = 58;
  trackerProvider.goalIds.free.michelin = 59;
  // LACOS
  trackerProvider.goalIds.buy.lacos = 60;
  trackerProvider.goalIds.test.lacos = 61;
  trackerProvider.goalIds.free.lacos = 62;
}

export default trackingConfig;
